export const terms = Object.freeze({
    dashboard: 'Dashboard',
    welcome: 'Hi [AGENT_NAME], let\'s make real estate happen.',
    last12Months: 'Last 12 Months',
    recruitingActivity: 'Recruiting Activity',
    last30Days: 'Last 30 days',
    seeAll: 'See All',
    savedAgentActivities: 'SAVED AGENT ACTIVITIES',
    noAgentsTrackedYet: 'No Agents Tracked Yet',
    noAgentsOnYourRadarYet: 'No agents on your radar yet.',
    saveOneToFollowTheirActivity: 'Save one to follow their activity.',
    noNewActivity: 'No New Activity',
    noNewActivityMessage: 'Your followed agents haven\'t had any recent updates.',
    allMlsAndPropertyTypes: 'All MLS & Property Types',
    transactionVolume: 'Transaction Volume',
    marketAverage: 'Market Average',
    selectedOffice: 'Selected Office',
    errorLoadingData: 'Failed to load activity data',
    closedSaleAt: 'Closed sale at',
    listed: 'Listed',
    agentProductivity: 'Agent Productivity',
    topProducers: 'Top Producers',
    atRisk: 'At Risk',
    noAgentActivityTitle: 'Awaiting Agent Activity',
    noAgentActivityMessage1: 'Agent productivity stats will appear here',
    noAgentActivityMessage2: 'once activity is recorded.',
    supplyAmpDemand: 'Supply & Demand',
    supplyOfInventoryTitle: (currentMsi) => `${currentMsi} Months Supply of Inventory`,
    averageDaysOnMarketTitle: (currentAvgDom) => `${currentAvgDom} Average Days on Market`,
    supplyOfInventory: (monthName, currentMsi, msiDirection) => `${monthName}'s Supply of Inventory is currently ${currentMsi} months. ${msiDirection} from the same period last year.`,
    averageDaysOnMarket: (monthName, currentAvgDom, avgDomDirection) => `${monthName}'s Average Days on Market is currently ${currentAvgDom} days. ${avgDomDirection} from the same period last year.`,
    upwardShift: 'This is an UPWARD shift',
    downwardShift: 'This is a DOWNWARD shift',
    noChange: 'There is NO CHANGE',
    emptySupplyAndDemandData: 'No supply and demand data available for the selected MLS.'
});

export const periodDropdownItems = [
    {
        dataLwtId: 'no-split-item1',
        itemText: terms.last12Months,
        key: 'item_1'
    },
];

export const viewTypes = {
    byOffice: { id: 'byOffice', label: "By Office" },
    byBrokerage: { id: 'byBrokerage', label: "By Brokerage" },
};
